// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__ZE41E","border":"Textarea_border__8YAue","formControl":"Textarea_formControl__vgITT","invalid":"Textarea_invalid__dBlfH"};